import { audio } from "common";
import { Accessor, Setter, createSignal } from "solid-js";

export type PlayStatus = 'playing' | 'paused' | 'stopped' | 'recording';

export class AudioPlayerContext {
    allowRecordModal: boolean = true;
    waveform: Accessor<Float32Array>;
    setWaveform: Setter<Float32Array>;
    recordRenderer?: audio.RecordingRenderer;

    src: Accessor<string>;
    setSrc: Setter<string>;
    settingSrc?: Promise<void>;

    status: Accessor<PlayStatus>;
    setStatus: Setter<PlayStatus>;

    progress: Accessor<number>;
    setProgress: Setter<number>;

    srcName: string;
    identity: Accessor<string>;

    constructor(srcName: string, identity: Accessor<string>) {
        this.srcName = srcName;
        this.identity = identity;

        [this.src, this.setSrc] = createSignal('');
        [this.status, this.setStatus] = createSignal<PlayStatus>('stopped');
        [this.progress, this.setProgress] = createSignal(0);
        [this.waveform, this.setWaveform] = createSignal<Float32Array>(new Float32Array([]));
    }
}
